<template>
    <div class="news-entry" :class="$vuetify.theme.dark ? 'news-entry--dark' : ''">
        <span class="news-entry__text">{{ text }}</span>
        <img v-if="img" :src="img" class="news-entry__img" :style="imgWidthPercent !== 100 ? {width: imgWidthPercent + '%'} : null" :alt="text">
    </div>
</template>

<script>
    // Sdileny "blok" jedne novinky - recyklovan v News.vue (zalozka Novinky) i NewsPopup.vue
    // (popup po prihlaseni), viz docs/superpowers/specs/2026-08-27-changelog-seen-tracking-design.md.
    // Datum se zamerne nezobrazuje - samostatny sloupec na uzsich mobilech zbytecne zuzoval text (2026-08-28).
    export default {
        name: 'NewsEntry',
        props: {
            text: {type: String, required: true},
            img: {type: String, default: ''},
            // Volitelny uzsi obrazek pro konkretni polozku (zadani uzivatele
            // 2026-08-28 - "zmenši ten obrázek na 90% šíře popupu") - default
            // 100 zachovava puvodni chovani (CSS width:100% + max-width cap)
            // pro vsechny ostatni novinky beze zmeny.
            imgWidthPercent: {type: Number, default: 100},
        },
    }
</script>

<style scoped>
    .news-entry {
        padding: 12px 0;
        border-bottom: 1px solid rgba(0, 0, 0, .08);
    }

    /* cerny 8% okraj byl na tmavem pozadi karty skoro neviditelny */
    .news-entry--dark {
        border-bottom: 1px solid rgba(255, 255, 255, .12);
    }

    .news-entry__text {
        display: block;
    }

    .news-entry__img {
        display: block;
        width: 100%;
        max-width: 380px;
        margin: 10px auto 0;
        border-radius: 12px;
        box-shadow: 0 4px 14px rgba(0, 0, 0, .25);
        border: 3px solid #fff;
    }
</style>
